import Vue from "vue"
import MagicWand from "magic-wand-tool"
import "magic-wand-tool/dist/magic-wand.min.js"

Vue.use(MagicWand)
Vue.component("MagicWand", MagicWand)

export default MagicWand